
//https://stackoverflow.com/questions/5770990/sorting-tournament-seeds/59378639

export function getGameGridForNoOfTeams(noOfTeams){
    const table = getTable(noOfTeams);
    setBlocks(table );
    setBinary(table);
    let spielId = 0;
    const spielRaster = {}
    for ( let i = 0; i < table.size; i++ ) {
        if ( i%2===0 ) {
            spielId++
            spielRaster[spielId] = {
                team1Id: table.get("Row" + (i + 1)).get("Seed"),
                team2Id: null,
            }
        } else {
            spielRaster[spielId].team2Id = table.get("Row" + (i + 1)).get("Seed")
        }
    }
    return spielRaster;
}

function getTable(noOfTeams){
    const rowMap = getRowMap(noOfTeams);
    let table = new Map();
    for ( let i = 1; i <= noOfTeams; i++ ) {
        table.set("Row" + i, new Map(rowMap))
    }
    return table;
}

function getRowMap(noOfTeams){
    let rowMap = new Map();
    for (let exponent = 0; Math.pow(2, exponent) < noOfTeams; exponent++) {
        rowMap.set(exponent + 1, 0);
    }
    return rowMap;
}

function setBlocks(table){
    //console.log ("setBlocks", table);
    for ( let i = 2; i <= table.size; i++ ) {
        const row = table.get("Row" + i);
        //console.log ("row", row);
        for ( let j = 1; j <= row.size; j++ ) {
            const asterixRow = Math.pow(2, j)
            if ( (i-1) % asterixRow === 0 ) {
                row.set(j, "*");
            }
        }
    }
}

function setBinary(table){
    for ( let i = 1; i <= table.size; i++ ) {
        const row = table.get("Row" + i);
        let binary = ""
        if ( i > 1 ) {
            const prevRow = table.get("Row" + (i - 1));
            for ( let j = 1; j <= row.size; j++ ) {
                const prevValue = prevRow.get(j);
                const currentValue = row.get(j);

                if (currentValue === "*") {
                    row.set(j, prevValue);
                } else {
                    row.set(j, prevValue === 0 ? 1 : 0);
                }
                binary += row.get(j).toString();
            }
        } else {
            binary = "000"
        }
        row.set("Binary", binary);
        row.set("Seed", parseInt(binary, 2) + 1);
    }
}